var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status-tag",class:(_vm.localType + " " + _vm.size),style:(_vm.tagStyle)},[_c('span',{style:(_vm.labelStyle)},[_vm._v(_vm._s(_vm.localLabel))])])}
var staticRenderFns = []

export { render, staticRenderFns }